import React from 'react';
import { SectionHeading } from './SectionHeading';
import { TornEdge } from './TornEdge';
import { Reveal } from './Reveal';
const TEMPLE_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/576a32cd-f02a-4952-9378-6ee6a8d946fe.jpg';
const records = [{
  label: 'Consultas y Rituales',
  text: 'Consultas y prácticas espirituales realizadas de manera personalizada.'
}, {
  label: 'Atención personalizada',
  text: 'Cada consulta se aborda según las circunstancias de cada persona.'
}];
export function Trajectory() {
  return <section aria-labelledby="templo-title" className="relative overflow-hidden bg-plum py-20 sm:py-28" data-id="element-209" data-mp="13r2cdp2gi5yk">
      <TornEdge colorClassName="bg-plum" data-id="element-210" data-mp="1diyedb7nyg82" />
      <div aria-hidden="true" className="smoke-veil pointer-events-none absolute inset-0 opacity-40" data-id="element-211" data-mp="1dksyinb424b3" />
      <div className="relative mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-212" data-mp="g1q5wwyikbzy">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-213" data-mp="l1m8qsvh5xdx">
          <Reveal data-id="element-214" data-mp="2mckrn6ta848f">
            <div className="relative bg-paper p-3 shadow-paper" data-id="element-215" data-mp="2mazynlmm8tco">
              <div className="fold-corner relative overflow-hidden" data-id="element-216" data-mp="2hcq1j5hbziof">
                <img src={TEMPLE_IMAGE} alt="Interior de un templo espiritual en penumbra con arcos de piedra, velas encendidas en candelabros de plata y un altar con cartas de tarot y amatistas" className="block h-full w-full object-cover" loading="lazy" data-id="element-217" data-mp="2hfkmcy49b5id" />
                <div aria-hidden="true" className="absolute inset-0 bg-plum/30 mix-blend-multiply" data-id="element-218" data-mp="1ylp2khg7nn4v" />
              </div>
              <span aria-hidden="true" className="absolute bottom-3 right-3 h-7 w-7 border-l border-t border-gold/50 bg-paper" data-id="element-219" data-mp="1pmbsbmk9iuj3" />
              <p className="mt-3 font-folio text-[0.6rem] uppercase tracking-[0.2em] text-ink/70" data-id="element-220" data-mp="3nzc3we7scil6">
                Archivo fotográfico · Templo de Ayuda
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.1} data-id="element-221" data-mp="1m44jcdhetdxl">
            <SectionHeading id="templo-title" folio="Sección VI · Trayectoria y experiencia" title="Templo de Ayuda" align="left" data-id="element-222" data-mp="1m4eai4e6xr4v">
              <p className="text-[0.98rem] leading-relaxed text-body sm:text-lg" data-id="element-223" data-mp="1cdjpt4glezlj">
                Ofrecemos consultas y prácticas espirituales tradicionales con
                atención personalizada para personas interesadas en orientación
                espiritual y rituales tradicionales.
              </p>
            </SectionHeading>

            <dl className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-224" data-mp="1r2y0cfvwnn2i">
              {records.map(record => <div key={record.label} className="border border-gold/40 bg-ink/60 p-6" data-id="element-225" data-mp="1w4eyi3n08vfe">
                  <dt className="font-folio text-[0.62rem] uppercase tracking-[0.22em] text-gold" data-id="element-226" data-mp="knooe9fgnjgi">
                    {record.label}
                  </dt>
                  <dd className="mt-3 text-sm leading-relaxed text-body" data-id="element-227" data-mp="c87qrmx1lv88">
                    {record.text}
                  </dd>
                </div>)}
            </dl>
          </Reveal>
        </div>
      </div>
    </section>;
}